import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { environment } from './environments/environment';
import {ModeratModule} from "./app/moderat/moderat.module";

Sentry.init({
  dsn: "https://1a1e0e86e3b345af87416a3ccaece6e3@sentry.co2online.de/4",
  beforeBreadcrumb(breadcrumb, hint) {
    if(breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,

  // ignore some errors
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ]
});
Sentry.setTag('page_locale', navigator["browserLanguage"]?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(ModeratModule)
  .catch(err => console.error(err));
